export const tasksToSections = (module, tasks) => {
  let absIndex = 0;
  if (!tasks || !module) { return []; }

  const levels = module.metadata.levels.reduce((acc, level) => {
    acc[level.id] = level.title;
    return acc;
  }, {});

  const sections = Object.keys(levels).map((levelId) => {
    // eslint-disable-next-line eqeqeq
    const levelTasks = tasks.filter((task) => (task.level == levelId));
    return {
      level: levelId,
      title: levels[levelId],
      data: levelTasks.map((task) => {
        const t = {
          ...task,
          absIndex,
        };
        absIndex += 1;
        return t;
      }),
    };
  });

  return sections;
};
